@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card company-document-form-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">{{ pageTitle }}</h3>
    @if (code) {
      <span class="badge company-document-code-badge">{{ code }}</span>
    }
  </div>

  <div class="card-body">
    <company-documents-form
      [companyDocument]="companyDocument"
      [companyDocumentId]="companyDocumentId"
      [isEditPage]="isEditMode"
      (onSavedData)="onFormSavedData($event)">
    </company-documents-form>
  </div>
</div>
